import React from 'react';

const CustomerReviews = () => {

    const reviewers = [
        {
          name: "Aditi Sharma",
          quote: "The team provided exceptional service. They were professional, efficient, and helped us achieve all our goals in a timely manner.",
          imgSrc: "path/to/aditi-image.jpg",
        },
        {
          name: "Rajesh Patel",
          quote: "I was thoroughly impressed with the quality of service. The attention to detail and customer care were outstanding throughout the process.",
          imgSrc: "path/to/rajesh-image.jpg", 
        },
        {
          name: "Sanya Gupta",
          quote: "Absolutely thrilled with the service! The team went above and beyond, and I would highly recommend them to anyone looking for reliable and top-notch service.",
          imgSrc: "path/to/sanya-image.jpg",
        },
        {
          name: "Anil Kumar",
          quote: "A wonderful experience from start to finish. The team was attentive, responsive, and made sure all our needs were met. I'm extremely satisfied with the results.",
          imgSrc: "path/to/anil-image.jpg", 
        },
      ];
      
      
  return (
    <section className="bg-gradient-to-r from-[#f5f9fc] to-[#eaf4fb] py-16">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-3xl font-bold text-gray-800 mb-8">Customer's Review</h2>
      <div className="flex flex-wrap justify-center gap-8">
        {reviewers.map((reviewer, index) => (
          <div
            key={index}
            className="w-72 bg-white p-6 rounded-lg shadow-lg border border-gray-200"
          >
            <div className="w-20 h-20 mx-auto mb-4">
              <img
                src={reviewer.imgSrc || "https://via.//placeholder.com/80"}
                alt={reviewer.name}
                className="rounded-full object-cover border-4 border-blue-100"
              />
            </div>
            <h3 className="text-lg font-semibold text-gray-800">
              {reviewer.name}
            </h3>
            <p className="text-gray-600 mt-2 text-sm italic">“{reviewer.quote}”</p>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default CustomerReviews;
